<template>
  <div class="field has-addons">
    <div class="control is-expanded">
      <input
        class="input has-text-centered"
        type="search"
        placeholder="» » » » » » find me « « « « « «"
        v-model="search"
        @input="changeSearch"
      />
    </div>
    <div class="control">
      <a class="button is-info" @click="changeSearch">Search</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
    }
  },
  computed: {
    type() {
      return this.$store.state.plugins.type;
    },
  },
  methods: {
    changeSearch() {
      this.$store.dispatch("changeSearch", this.search);
    }
  },
  watch: {
    type: async function (_) {
      this.search = ""
      this.changeSearch()
    },
  }
};
</script>